import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import { useMemo } from "react";
import { KeywordBase, useGetKeywordBaseData } from "@api/useGetKeywordBaseData";
import {
    HOME_TABLE_METRICS_POLARITY_ORDER,
    MetricForTable,
    useMapMetricsForTable,
} from "@models/Metric";


const REQUEST_PATH: keyof paths = '/api/Search/GetTable';
export type HomeTableRawNormRequestPayload = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageRequest"];
type ResponseData = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageTableResponse"][];

export type HomeTableRawNormDataItem = KeywordBase & {
    base: number;
    metrics: MetricForTable[];
}

export function useHomeTableRawNormData(payload: HomeTableRawNormRequestPayload) {
    const getKeywordBaseData = useGetKeywordBaseData();
    const mapMetricsForTable = useMapMetricsForTable(HOME_TABLE_METRICS_POLARITY_ORDER);

    const response = useAxios<ResponseData, HomeTableRawNormRequestPayload>({
        url: REQUEST_PATH,
        method: 'post',
        payload,
    });

    const data = useMemo(
        (): HomeTableRawNormDataItem[] => {
            return (response.data ?? []).map(item => {
                const itemBase = getKeywordBaseData(item.id ?? 0);

                return {
                    ...itemBase,
                    base: item.base ?? 0,
                    metrics: mapMetricsForTable(item.metrics ?? []),
                };
            });
        },
        [response.data, getKeywordBaseData, mapMetricsForTable]
    );

    return {
        ...response,
        data,
    };
}